import React, { useEffect, useState } from 'react';

const MyTextarea = ({ maxLength = Infinity, TextAreaRef, value, minHeight, isLengthActive = true, placeholder = '', onChange, className }) => {
  useEffect(() => {
    handleInputChange(value)
  }, [value])

  const handleInputChange = (value) => {
    const newText = value;

    if (newText?.length <= maxLength) {
      if (typeof onChange === 'function') {
        onChange(newText);
      }
    }
  };

  return (
    <div>
      <div className={`relative `}>
        <textarea
          className={`outline-none border-1 p-[10px]  w-[100%] border-[#E3E8EF] rounded-[5px] ${className}`}
          style={{
            minHeight
          }}
          value={value}
          ref={TextAreaRef}
          onChange={(event) => handleInputChange(event.target?.value)}
          placeholder={placeholder}
        />
        {isLengthActive && (
          <div className="absolute right-3 bottom-3 text-[#8A92A6] text-[13px] font-light">
            {value?.length || 0}/{maxLength === Infinity ? '∞' : maxLength}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyTextarea;
